import * as React from "react";
import { Eye, WifiOff } from "lucide-react";
import { Button } from "@/components/ui/button";

export interface AttentionStripProps {
  machine: {
    id: string;
    name: string;
    offlineFor: string;
  };
  onInspect: (machineId: string) => void;
}

export function AttentionStrip({ machine, onInspect }: AttentionStripProps): React.ReactElement {
  return (
    <div
      role="status"
      aria-live="polite"
      className="border-rd-danger-500/30 mt-3.5 flex items-center gap-3.5 rounded-xl border bg-[#fdf4f1] px-[18px] py-3"
    >
      <span
        aria-hidden="true"
        className="grid h-[30px] w-[30px] shrink-0 place-items-center rounded-md bg-rd-danger-50 text-red-strong"
      >
        <WifiOff className="h-4 w-4" />
      </span>
      <p className="min-w-0 flex-1 text-[13px] text-text-primary">
        <b className="font-semibold">{machine.name} sem comunicação</b>
        <span className="text-[12.5px] text-text-secondary">
          {" "}
          · sensor offline há {machine.offlineFor} · OEE com confiança baixa enquanto isso
        </span>
      </p>
      <Button
        size="sm"
        variant="outline"
        onClick={() => onInspect(machine.id)}
        className="shrink-0"
      >
        <Eye className="h-3.5 w-3.5" aria-hidden="true" />
        Inspecionar máquina
      </Button>
    </div>
  );
}
